import { Button, Typography } from '@material-ui/core';
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import FilterListIcon from '@material-ui/icons/FilterList';
import { FilterValues, getFilters } from 'features/resultFiltering/resultFilteringSlice';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    filtersToggle: {
      position: 'sticky',
      top: 0,
      right: 0,
      boxShadow: theme.shadows[10],
      height: '100vh',
      width: '4rem',
      borderRadius: 0,
    },
    root: {
      paddingTop: theme.spacing(2),
      textTransform: 'none',
    },
    label: {
      transform: 'rotate(90deg)',
      width: '80vh',
    },
    icon: {
      marginRight: theme.spacing(2),
      marginBottom: -theme.spacing(1),
    },
  }),
);

interface Props {
  filtersVisible: boolean;
  setFiltersVisible: (_: boolean) => void;
  calcsLookup: { [key: string]: string };
}

const FilteringToggleButton = ({ filtersVisible, setFiltersVisible, calcsLookup }: Props) => {
  const classes = useStyles();
  const { t } = useTranslation(['common', 'results']);

  const filters = useSelector(getFilters);

  const activeFilters = Object.entries(filters)
    .map((filter) => {
      const [name, { values, lowerChanged, upperChanged }] = filter;
      if (lowerChanged || upperChanged) {
        return [name, values, lowerChanged, upperChanged];
      } else {
        return undefined;
      }
    })
    .filter((f) => f !== undefined) as Array<[string, FilterValues, boolean, boolean]>;

  const activeFiltersText = activeFilters
    .map(
      ([name, [vl, vu], lowerChanged, upperChanged]) =>
        (lowerChanged ? `${+vl.toFixed(2)}<` : '') +
        calcsLookup[name] +
        (upperChanged ? `<${+vu.toFixed(2)}` : ''),
    )
    .join('  •  ');

  return (
    <Button
      classes={{ root: classes.root, label: classes.label }}
      className={classes.filtersToggle}
      onClick={() => setFiltersVisible(!filtersVisible)}
      fullWidth
    >
      <Typography noWrap variant="body2">
        <FilterListIcon className={classes.icon} />
        {Object.keys(calcsLookup).length && activeFilters.length
          ? activeFiltersText
          : t('results:filters').toUpperCase()}
      </Typography>
    </Button>
  );
};

export default FilteringToggleButton;
